var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4323 14.1042V5.4726H1.5677V14.1042H12.4323ZM12.4323 1.54247C12.8455 1.54247 13.2101 1.70163 13.526 2.01996C13.842 2.33829 14 2.70559 14 3.12187V14.1042C14 14.5205 13.842 14.8878 13.526 15.2061C13.2101 15.4999 12.8455 15.6469 12.4323 15.6469H1.5677C1.1302 15.6469 0.753465 15.4999 0.437492 15.2061C0.145826 14.9123 -7.62939e-06 14.545 -7.62939e-06 14.1042V3.12187C-7.62939e-06 2.70559 0.145826 2.33829 0.437492 2.01996C0.753465 1.70163 1.1302 1.54247 1.5677 1.54247H2.33333V-0.000198364H3.90103V1.54247H10.099V-0.000198364H11.6667V1.54247H12.4323ZM10.901 7.052V8.59467H9.33333V7.052H10.901ZM7.76562 7.052V8.59467H6.23437V7.052H7.76562ZM4.66666 7.052V8.59467H3.09895V7.052H4.66666Z",
    fill: "#D26985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.b60ba201d27c6731a3c68190db947d13.svg";
export { ForwardRef as ReactComponent };